<template>
  <article class="results-list__item" data-id="results-list-item">
    <div class="results-list__item-img" v-if="item.image">
      <!-- @TODO title? -->
      <picture>
        <source srcset="" sizes="100vw">
        <img :src="image" :alt="item.image_alt" title="">
      </picture>
    </div>
    <div class="results-list__content">

      <div class="top-request__wrapper container--large" v-if="this.route === 'professionalDevelopmentResources' && item.top_request==='1'">
        <div class="top-request">
          <svg xmlns="http://www.w3.org/2000/svg"
               width="16"
               height="16"
               viewBox="0 0 16 16">
            <path fill="currentColor"
                  fill-rule="evenodd"
                  d="M24.477 14.016L22.016 9 19.523 14.016 14 14.837 18.008 18.717 17.061 24.238 22.016 21.651 26.939 24.238 26.024 18.717 30 14.837z"
                  transform="translate(-14 -9)" />
          </svg>
          <span class="top-request__text">Top Request</span>
        </div>
      </div>

      <template v-if="!this.isFederalEducationFunding && !this.isProfessionalDevelopmentResources && !this.isNEATodayNewsAndArticles">
        <span class="results-list__tophat u-secondary-dark" v-if="item.article_type_friendly">{{ item.article_type_friendly }}</span>
        <span class="results-list__tophat u-secondary-dark" v-if="item.resource_type_friendly && !isResearchAndReports">{{ item.resource_type_friendly }}</span>
        <span class="results-list__tophat u-secondary-dark" v-if="item.action_type_friendly">{{ item.action_type_friendly }}</span>
        <span class="results-list__tophat u-secondary-dark" v-if="item.type === 'writer'">Writer</span>
      </template>
      <template v-if="this.isNEATodayNewsAndArticles">
        <span class="results-list__tophat u-secondary-dark" v-if="item.nea_today_section_friendly">{{ item.nea_today_section_friendly }}</span>
      </template>

      <a :href="href" v-if="title" :target="hasExternalLink ? '_blank' : null">
        <h3 class="results-list__title u-primary-very-dark u-hover-tertiary-dark u-medium-title u-sans-serif u-sans-serif-title u-type-28 u-type-until-bp-small-24" :class="{ 'has-external-link': hasExternalLink }">
          {{ title | strip }}

          <span v-if="hasExternalLink" class="results-list__external-link">
            <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg"><path d="m7.94 0 2.605 2.624L5 8.169l1.117 1.117 5.545-5.546 2.624 2.606V0H7.94zm5.4 12.705H1.66V1.58H7.5L5.84 0H1.66A1.64 1.64 0 0 0 .488.465C.163.775 0 1.147 0 1.581v11.124c0 .434.163.806.488 1.116.326.31.716.465 1.172.465h11.68a1.64 1.64 0 0 0 1.172-.465c.325-.31.488-.682.488-1.116V8.724l-1.66-1.581v5.562z" fill="currentColor" fill-rule="evenodd"/></svg>
          </span>

        </h3>
      </a>

      <div class="results-list__bowtie-wrapper" v-if="hasLearnuponCost || hasDevelopedBy || isMembersOnlyCourse">
        <div class="results-list__bowtie" v-if="isMembersOnlyCourse">
          <span class="results-list__formembersonly u-primary-dark">
            <span>For Members</span>
            <span class="results-list__formembersonly-svg u-secondary-dark">
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11.667" viewBox="0 0 10 11.667"><path fill="currentColor" fill-rule="evenodd" d="M2.65.984C3.306.328 4.089 0 5 0s1.694.328 2.35.984c.656.655.983 1.439.983 2.35V5H10v6.667H0V5h1.667V3.334c0-.911.327-1.695.983-2.35M6.183 2.15c-.310826-.31729-.738924-.49208-1.183-.483-.444076-.00908-.872174.16571-1.183.483-.317914.31089-.493093.73943-.484 1.184V5h3.334V3.334c.009093-.44457-.166086-.87311-.484-1.184"/></svg>
            </span>
          </span>
        </div>

        <div class="results-list__bowtie" v-if="hasLearnuponCost">
          <span class="results-list__cost">
            <span class="results-list__cost-label u-primary-dark">Cost:</span>
            <span class="results-list__cost-value">
              {{ item.lu_pricing }}
            </span>
          </span>
        </div>

        <div class="results-list__bowtie" v-if="hasDevelopedBy">
          <span class="results-list__developedby">Developed by: </span>
          <span>{{ author }}</span>
        </div>
      </div>

      <div class="results-list__item-meta">
        <span class="results-list__type u-sans-serif u-type-15" v-if="!isProfessionalDevelopmentResources && !this.isNEATodayNewsAndArticles && item.nea_today==='1'">{{ newFromNeaTodayFriendly }}</span>
        <span class="results-list__type u-sans-serif u-type-15" v-if="!isProfessionalDevelopmentResources && item.campaign_friendly">{{ item.campaign_friendly }}</span>
        <span class="results-list__author u-sans-serif u-type-12" v-if="!isProfessionalDevelopmentResources && author">by: {{ author }}</span>
        <span class="results-list__author u-sans-serif u-type-12" v-if="item.type === 'writer' && item.writer_job_title">{{ item.writer_job_title }}</span>
        <!-- show publish date only if content type is article and article type is not "Member Spotlight" -->
        <span class="results-list__date u-sans-serif u-type-12" v-if="((!isProfessionalDevelopmentResources && item.article_type && item.article_type!=='37') || this.isNEATodayNewsAndArticles) && item.publish_date">{{ item.publish_date | date }}</span>
      </div>
      <div class="results-list__summary u-sans-serif u-type-16" v-if="item.summary">
        {{ item.summary | strip }}
      </div>
    </div>
  </article>
</template>

<script>
  const neaTodayFilters = window.drupalSettings.searchFilters.nea_today
  export default {
    name: 'ResultsListItem',
    props: ['item'],
    data() {
      return {
        nea_today: neaTodayFilters,
      }
    },
    computed: {
      hasLearnuponCost() {
        return !!this.item.lu_pricing
      },
      hasDevelopedBy() {
        return this.isProfessionalDevelopmentResources && this.item.author
      },
      hasExternalLink() {
        return this.isLearnuponCourse
      },
      isFederalEducationFunding() {
        return this.route === 'federal_education_funding'
      },
      isLearnuponCourse() {
        return this.item.is_learnupon_course
      },
      isMembersOnlyCourse() {
        return this.isLearnuponCourse && this.item.lu_members_only_course === '1'
      },
      isProfessionalDevelopmentResources() {
        return this.route === 'professional_learning_resources'
      },
      isResearchAndReports() {
        return this.route === 'research_and_reports'
      },
      isSchoolMe() {
        return this.route === 'school_me'
      },
      isNEATodayNewsAndArticles() {
        return this.route === 'nea_today_news_and_articles'
      },
      route () {
        return this.$route.name
      },
      href () {
        if (this.isLearnuponCourse) {
          return this.item.link
        }

        if(this.item.path) {
          return this.item.path
        }
        else {
          return this.item.url
        }
      },
      title () {
        // PDFs and other indexed files do not have a path
        return this.item.path ? this.item.title : decodeURIComponent(this.item.url.substring(this.item.url.lastIndexOf('/') + 1));
        //return this.item.path ? this.item.title : this.truncateBody(5); // PDFs' flattened content
      },
      summary () {
        return this.item.path ? this.item.summary : this.truncateBody(25);
      },
      author () {
        return this.item.path ? this.item.author : false
      },
      image () {
        return this.item.image
      },
      newFromNeaTodayFriendly () {
        return this.nea_today['From NEA Today'].name.replace("From ", "");
      }
    },
    methods: {
      isTruncatable(length, data) {
        return data.split(' ').length > (length - 1)
      },
      truncateBody(length) {
        // body contains PDFs' flattened content
        if (this.isTruncatable(length, this.item.body)) {
          return `${this.item.body.split(' ').slice(0, (length - 1)).join(' ')}...`
        }
        return this.item.body
      },
    }
  }
</script>
